import { useBackend, useBackendMutation } from '@/backend';

export const useMission = () => useBackend('wealth:get:mission/', {});

export const useClaimReward = () =>
  useBackendMutation('wealth:post:missions/claim-reward/', {
    revalidate: ['wealth:*'],
  });
